import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Typography } from '@material-ui/core';
import opacity from '../common/theme/colors/opacity';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ( {
    content: {
        backgroundClip: 'padding-box',
        backgroundColor: theme.palette.background.paper,
        overflowY: 'auto',
    },
    contentText: {
        paddingLeft: theme.spacing.unit * 3,
        paddingRight: theme.spacing.unit * 3,
    },
    paperScrollPaper: {
        overflowY: 'visible'
    },
    subtitle: {
        color: opacity.black60,
        paddingLeft: theme.spacing.unit * 3,
    },
    title: {
        paddingBottom: 0,
    },
    titleContainer: {
        paddingBottom: theme.spacing.unit * 3,
    },
} );

const Modal = ( { open, onClose, maxWidth = 'sm', children, dialogContentText,
    title, subTitle, modalActions, classes, dataAutomationId } ) => {
    return (
        <Dialog
            classes={{ paperScrollPaper: classes.paperScrollPaper }}
            open={open}
            onClose={onClose}
            maxWidth={maxWidth}
            fullWidth={true}
            disableBackdropClick={true}
            data-automation-id={dataAutomationId}
        >
            <div className={classes.titleContainer}>
                {
                    title &&
                    ( <DialogTitle
                        className={classes.title}
                        data-automation-id="modal-title"
                    >
                        {title}
                    </DialogTitle> )
                }
                {
                    subTitle &&
                    ( <Typography
                        variant="subtitle1"
                        className={classes.subtitle}
                        data-automation-id="modal-subtitle"
                    >
                        {subTitle}
                    </Typography> )
                }
            </div>
            {
                dialogContentText &&
                <DialogContentText className={classes.contentText} >{dialogContentText}</DialogContentText>
            }
            <DialogContent className={classes.content}>{children}</DialogContent>
            {
                modalActions &&
                <DialogActions>{modalActions}</DialogActions>
            }
        </Dialog>
    );
};

Modal.propTypes = {
    children: PropTypes.oneOfType( [PropTypes.element, PropTypes.array] ),
    classes: PropTypes.object,
    dataAutomationId: PropTypes.string.isRequired,
    dialogContentText: PropTypes.string,
    maxWidth: PropTypes.oneOf( ['xs', 'sm', 'md', 'lg', 'xl'] ),
    modalActions: PropTypes.element,
    onClose: PropTypes.func,
    open: PropTypes.bool.isRequired,
    subTitle: PropTypes.string,
    title: PropTypes.string,
};

export default withStyles( styles )( Modal );
